import React from "react";
import styles from "./home.module.css";
import { Col, Container, Row } from "react-bootstrap";
import {
  // Heading,
  MainHeading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import AboutSection from "../../Components/AboutSection/AboutSection";
import Categories from "../../Components/Categories/Categories";
import FaqSection from "../../Components/FaqSection/FaqSection";
import InputboxSection from "../../Components/InputboxSection/InputboxSection";
import SliderService from "../../Components/Services/SliderService";
import SliderTestimonial from "../../Components/Testimonial/SliderTestimonial";

export const FormUi = () => {

  return (
    <div className={styles.image_section}>
      <p className="h5">Get a Quote</p>
      <p className="fs-6 mb-2">Request a free quote - let’s build your custom solution!</p>

      <form name="contact" action={"/contact"} method="POST">
        <input type="hidden" name="form-name" value="contact" />
        <div className="mb-2">
          <label htmlFor="name" className="form-label">Your Name</label>
          <input type="text" name="name" required id="name" placeholder="Enter full name" className="form-control" />
        </div>

        <div className="mb-2">
          <label htmlFor="number" className="form-label">Your Number</label>
          <input type="tel" name="number" required id="number" placeholder="+91" className="form-control" />
        </div>

        <div className="mb-2">
          <label htmlFor="budget" className="form-label">Your Budget</label>
          <input type="number" name="budget" required id="budget" placeholder="INR" className="form-control" />
        </div>

        <div className="mb-2">
          <label htmlFor="message" className="form-label">Message</label>
          <textarea type="text" name="message" required id="message" placeholder="Describe your need in short" className="form-control">
          </textarea>
        </div>

        <div>
          <button type="submit" className={styles.cs_button} style={{
            background: 'rgb(43, 76, 201)',
            color: 'rgb(255, 255, 255)',
            width: '100%',
            borderRadius: '6px',
            border: 'none',
            padding: '10px'
          }}>Submit</button>
        </div>
      </form>
    </div>
  )
}

const Home = ({handleShow}) => {

  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Container>
          <Row>
            <Col md={7} sm={12}>
              <div className={styles.right_section}>
                <div className={styles.tabContainer}>
                  <div className={styles.tabs}>
                    <button
                      className={`${styles.tab_1} ${styles.active}`}
                    >
                      Startup Assist
                    </button>
                    <button
                      className={`${styles.tab_2}`}
                    >
                      one-stop solution for all
                    </button>
                  </div>
                </div>
                <MainHeading color="#2A2A2A" size="3rem">
                  Empowering Businesses with Digital Innovation
                </MainHeading>
                <Paragraph color="#2A2A2A">
                  <ul className={styles.ulStyle}>
                    <li>✅ Scalable & secure applications</li>
                    <li>✅ User-friendly, conversion-driven designs</li>
                    <li>✅ Custom solutions tailored to your business needs</li>
                  </ul>
                </Paragraph>
                <Paragraph color="#2A2A2A">
                  Custom Software | Web & Mobile Apps | UI/UX Excellence | SaaS Development
                </Paragraph>

                <div className={styles.btn_section}>
                  <button onClick={handleShow} style={{ background: "#E5E5E5", color: "#282323" }}>Get a Quote</button>
                  <button onClick={handleShow} style={{ background: "#2B4CC9", color: "#fff" }}>
                    Contact Us
                  </button>
                </div>
              </div>
            </Col>
            <Col md={5} sm={12}>
              <FormUi />
            </Col>
          </Row>
        </Container>

        <div id="about">
          <AboutSection handleShow={handleShow} />
        </div>

        <div id="program">
          <SliderService handleShow={handleShow} />
        </div>

        <div id="vertical">
          <Categories handleShow={handleShow} />
        </div>

        {/* <div id="packages">
          <PackageSection />
        </div>

        <div id="resource">

          <Stories />
        </div> */}

        <div id="policies">
          <SliderTestimonial />
        </div>

        <div id="faq">
          <FaqSection handleShow={handleShow} />
        </div>
        <InputboxSection />
      </div>
    </React.Fragment>
  );
};

export default Home;
